<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>{{dialogData.title}}</h4>

    <button
      mat-button
      [mat-dialog-close]=""
      (click)="closeHelper()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content
    class="dialog-content"
    [innerHTML]="dialogData.content"
  ></mat-dialog-content>
  <hr class="solid" />

  <div mat-dialog-actions>
    <button
      mat-button
      (click)="closeHelper()"
      mat-dialog-close
      class="button-close"
    >
      Close
    </button>
  </div>
</div>
